import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import { Organization } from '../../reducers/organizationReducer'
import { useSelector } from 'react-redux'
import { Popover } from 'antd'
import { InfoCircleTwoTone } from '@ant-design/icons'

const values = [
  { id: 1, value: '1' },
  { id: 2, value: '2' },
  { id: 3, value: '3' },
  { id: 4, value: '4' },
  { id: 5, value: '5' },
  { id: 6, value: '6' },
  { id: 7, value: '7' },
  { id: 8, value: '8' },
  { id: 9, value: '9' },
  { id: 10, value: '10' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

async function onNumberSelect(element, setSelected, updateCompanySetting) {
  await updateCompanySetting('maxReviewersInTeamToInvite', element.value)
  setSelected(element)
}
const SelectNumber = ({ updateCompanySetting }) => {
  const organization = useSelector(Organization.selectors.getOrganization)
  const { setting } = organization
  const initialElement = values.find(
    (val) => val.value === setting?.maxReviewersInTeamToInvite?.toString(),
  )
  const [selected, setSelected] = useState(initialElement)

  return (
    <Listbox
      value={selected}
      onChange={(value) => onNumberSelect(value, setSelected, updateCompanySetting)}
    >
      {({ open }) => (
        <>
          <div className="mt-1 relative">
            <Listbox.Button className="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm">
              <span className="block truncate">{selected?.value}</span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options
                className="absolute z-10 mt-1 w-30 bg-white shadow-lg max-h-60 right-0
              rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
              >
                {values.map((element) => (
                  <Listbox.Option
                    key={element.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'text-white bg-hoverPrimary' : 'text-gray-900',
                        'cursor-default select-none relative py-2 pl-8 pr-4',
                      )
                    }
                    value={element}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? 'font-semibold' : 'font-normal',
                            'block truncate',
                          )}
                        >
                          {element.value}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-hoverPrimary',
                              'absolute inset-y-0 left-0 flex items-center pl-1.5',
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}

export const MaxEngineersInTeamReviewToInviteSetting = ({ updateCompanySetting }) => {
  return (
    <div className="flex justify-between mt-6">
      <p className="flex mb-0 self-center">
        Set the maximum number of reviewers to invite in PR channels when you request a
        team as reviewer
        <span className="pl-3 flex self-center">
          <Popover
            content={
              <p className="w-96">
                We recommend keeping this number low (~3). Inviting too many people in
                channels creates unnecessary notifications and has a negative impact on
                your team mental load and productivity.{' '}
              </p>
            }
          >
            <InfoCircleTwoTone twoToneColor="#0049ff" />
          </Popover>
        </span>
      </p>
      <SelectNumber updateCompanySetting={updateCompanySetting} />
    </div>
  )
}
